import { Schema } from "effect";

export const MessageSmsKind = Schema.Literal(
  "number",
  "attentive",
  "postscript",
);
export type MessageSmsKind = typeof MessageSmsKind.Type;

export const MessageSmsService = Schema.Literal("SMS", "MMS", "RCS");
export type MessageSmsService = typeof MessageSmsService.Type;
